import {
  SET_CALL_DIRECTION,
  SET_PHONE_FIELD_VALUE,
  SET_SUBSCRIBER,
  SET_IS_CONTROL_PANEL_VISIBLE,
  SET_NUM_PAD_VISIBLE,
  SET_PHONE_FIELD_POS,
  SET_SILENT_MODE,
  SET_RINGTONE_PLAY_ERROR,
  SET_RINGTONE_DEVICES_DATA,
  SET_SELECTED_RINGTONE_DEVICE,
  SET_USER_MEDIA_ERROR,
  SET_SERVICE_COMPANY,
  SET_COMPANY_VISIBLE,
} from './actionTypes';

export const setCallDirection = (direction) => {
  return {
    type: SET_CALL_DIRECTION,
    payload: direction,
  };
};

export const setPhoneFieldValue = (value) => {
  return {
    type: SET_PHONE_FIELD_VALUE,
    payload: value,
  };
};

export const setCompanyVisible = (value) => {
  return {
    type: SET_COMPANY_VISIBLE,
    payload: value,
  };
};

export const setServiceCompanyValue = (value) => {
  return {
    type: SET_SERVICE_COMPANY,
    payload: value,
  };
};

export const setSubscriber = (subscriber) => {
  return {
    type: SET_SUBSCRIBER,
    payload: subscriber,
  };
};

export const setIsControlPanelVisible = (visible) => {
  return {
    type: SET_IS_CONTROL_PANEL_VISIBLE,
    payload: visible,
  };
};

export const setNumPadVisible = (visible) => {
  return {
    type: SET_NUM_PAD_VISIBLE,
    payload: visible,
  };
};

export const setPhoneFieldPos = (pos) => {
  return {
    type: SET_PHONE_FIELD_POS,
    payload: pos,
  };
};

export const setSilentMode = (booleanVal) => {
  return {
    type: SET_SILENT_MODE,
    payload: booleanVal,
  };
};

export const setRingtonePlayError = (err) => {
  return {
    type: SET_RINGTONE_PLAY_ERROR,
    payload: err,
  };
};

export const setRingtoneDevicesData = (data) => {
  return {
    type: SET_RINGTONE_DEVICES_DATA,
    payload: data,
  };
};

export const setSelectedRingtoneDevice = (deviceId) => {
  return {
    type: SET_SELECTED_RINGTONE_DEVICE,
    payload: deviceId,
  };
};

export const setUserMediaError = (err) => {
  return {
    type: SET_USER_MEDIA_ERROR,
    payload: err,
  };
};
